import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdCreativeStudio from "@/pages/admin/AdCreativeStudio";

export const Route = createFileRoute("/admin/ad-studio")({
  head: () => pageHead("Admin \u2014 Ad Studio \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdCreativeStudio,
});
